import React from 'react';

import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { SplitPageResultsLoader } from '@confluence/page-splitter/entry-points/SplitPageResults.tsx';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';

export const PageSplitRoute = ({ params }: RouteMatch) => {
	const { contentId, spaceKey } = params;

	if (!expValEquals('confluence-page-splitter', 'isEnabled', 'Test')) {
		return <NotFound />;
	}

	return <SplitPageResultsLoader spaceKey={spaceKey} contentId={contentId} />;
};

PageSplitRoute.NAVIGATION_PARAMS = ({ name, params }: RouteMatch) => {
	const { contentId, spaceKey, contentSlug } = params;

	if (!expValEquals('confluence-page-splitter', 'isEnabled', 'Test')) {
		return false;
	}

	return {
		Screen: {
			screenEvent: { name: 'pageSplitScreen', id: contentId },
			pageState: {
				routeName: name,
				spaceKey,
				contentId,
				contentType: 'page',
				contentSlug: contentSlug || '',
			},
			showPremiumOnboarding: false,
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
			isViewPage: false,
		},
	};
};
